import { t } from "@/i18n-js/instance";
import { Form } from "@circle-react-uikit/Form";
import { templateLocaleNamespace } from "../UpdateTemplateContent";

const NAME_MAX_LENGTH = 140;

export const TemplateNameField = ({ checked }: { checked: boolean }) => {
  if (!checked) {
    return null;
  }
  return (
    <Form.Item
      name="name"
      label={t([templateLocaleNamespace, "template_name"])}
      hideDescription
      hideBorder
      placeholder={t([templateLocaleNamespace, "template_name_placeholder"])}
      isFirstChild
      labelClassName="sr-only"
      className="!pt-4"
      rules={{
        required: {
          value: !!checked,
          message: t([templateLocaleNamespace, "template_name_required"]),
        },
        maxLength: {
          value: NAME_MAX_LENGTH,
          message: t([templateLocaleNamespace, "template_name_too_long"], {
            numOfCharacters: NAME_MAX_LENGTH,
          }),
        },
      }}
    >
      <Form.Input autoFocus />
    </Form.Item>
  );
};
